import React from "react";
import { Player } from 'video-react';
import ClapingoLogo from "../assets/logo.svg";

const Recording = (props) => {
    // const { url } = useParams();
    console.log(props)
    console.log(props.history.location.search.split("=")[1])
    const url = props.history.location.search.split("=")[1];
    const openLink = () => window.open(url);
     return (
        <div className="videoplayer mt-5 mt-md-0">
            <div className="pt-5 d-flex justify-content-around">
            <img
              src={ClapingoLogo}
              alt=""
              className="logo"
            />
            <button onClick={() => openLink()}
             className="button">Download</button>
            </div>
            
            
            <div className="container  mt-4 pb-md-5" >
                 <div className=" p-0" >
                <Player className="player ml-md-4 " >
                <source src={url}/>
                </Player>
               
                </div>
            </div>
        </div>
    );
};

export default Recording;